const videoBaseURL = `${process.env.REACT_APP_BUCKET}/videos/`;

export default videoBaseURL;
